import moment from "moment";
import * as Yup from "yup";
// import { useTranslation } from "react-i18next";

export const LoginSchema = Yup.object().shape({
  first_name: Yup.string()
    .required("Required")
    .matches(/^(?![\s-])[\w\s-]+$/, "Enter a valid name"),
  last_name: Yup.string()
    .required("Required")
    .matches(/^(?![\s-])[\w\s-]+$/, "Enter a valid name"),
  // hebrew_name: Yup.string().required('Required'),
  // middle_name: Yup.string().required('Required'),
});

export const Step2Schema = Yup.object().shape({
  email_address: Yup.string().email("Wrong email format"),

  phone_number: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(16, "Maximum 16 symbols"),

  date_of_birth: Yup.string().test(
    "DOB",
    "Please select valid date of birth",
    (value) => {
      if (!value) return true;
      return moment().diff(moment(value), "days") >= new Date().getDay();
    }
  ),
});

export const AccountInfoSchema = Yup.object().shape({
  family_admin_name: Yup.string().required("Required"),
  mailLabelName: Yup.string().required("Required"),
});
export const AddNewMemberSchema = Yup.object().shape({
  family_name: Yup.string()
    .required("Required")
    .matches(/^(?![\s-])[\w\s-]+$/, "Enter a valid name"),
  // first_name: Yup.string().required("Required"),
  // // middle_name: Yup.string().required("Required"),
  // last_name: Yup.string().required("Required"),
  // hebrew_name: Yup.string().required("Required"),
  // // title: Yup.string().required("Required"),
  // // profile_img: Yup.string().required("Required"),
  // date_of_birth: Yup.string().test(
  //   "DOB",
  //   "Please select valid date of birth",
  //   (value) => {
  //     if (!value) return true;
  //     return moment().diff(moment(value), "days") >= new Date().getDay();
  //   }
  // ),
  // email_address: Yup.string()
  //   .email("Wrong email format")
  //   .min(3, "Minimum 3 symbols")
  //   .max(50, "Maximum 50 symbols"),
  // phone_number: Yup.string()
  //   .min(3, "Minimum 3 symbols")
  //   .max(16, "Maximum 16 symbols"),
  // // address: Yup.string().required("Required"),
  // // city: Yup.string().required("Required"),
  // // zip_code: Yup.string().required("Required"),
});
export const AddNewUserSchema = Yup.object().shape({
  first_name: Yup.string()
    .max(40)
    .required("Required"),
  last_name: Yup.string()
    .max(40)
    .required("Required"),
  permission: Yup.string().required("Required"),
  account: Yup.string().required("Required"),
});
export const AddNewAccountSchema = Yup.object().shape({
  first_name: Yup.string()
    .max(20)
    .required("Required"),
  last_name: Yup.string()
    .max(20)
    .required("Required"),
  account_type: Yup.string().required("Required"),
  account_sub_type: Yup.object().shape({
    label: Yup.string().required("Required"),
    value: Yup.string().required("Required"),
  }),
  billing_type: Yup.object().shape({
    label: Yup.string().required("Required"),
    value: Yup.string().required("Required"),
  }),
});

export const newTransaction = Yup.object().shape({
  account_name: Yup.object()
    .shape({
      label: Yup.string().required("Required"),
      value: Yup.string().required("Required"),
    })
    .required("Required"),
  payment_date: Yup.date().required("Required"),
  due_date: Yup.date().required("Required"),
  Ledger: Yup.object()
    .shape({
      label: Yup.string().required("Required"),
      value: Yup.string().required("Required"),
    })
    .required("Required"),
  total_amount: Yup.number().required("Required"),
});

export const AddNewChargeSchema = Yup.object().shape({
  first_name: Yup.string()
    .required("Required")
    .matches(/^(?![\s-])[\w\s-]+$/, "Enter a valid name"),
});

export const CreateInvoiceSchema = Yup.object().shape({
  member_id: Yup.string().required("Required"),
  to: Yup.string().required("Required"),
  interval: Yup.string().required("Required"),
  billingAddress: Yup.string().required("Required"),
  account_id: Yup.string().required("Required"),
  addInvoice: Yup.array().of(
    Yup.object()
      .shape({
        productN: Yup.string().required("Required"),
        price: Yup.number().required("Required"),
        // tax: Yup.number().required("Required"),
        qty: Yup.number().min(1),

        tax: Yup.number().min(0),
      })
      .required("Required")
  ),
  // add_discount: Yup.number().when(
  //   "additinalDiscount",

  //   (additinalDiscount, schema) => {
  //     if (additinalDiscount !== undefined) {
  //       return schema.min(1).required("field required");
  //     } else {
  //       return schema;
  //     }
  //   }
  // ),
});
export const AddMournersSchema = Yup.object().shape({
  account: Yup.string().required("Required"),
  relation: Yup.string().required("Required"),
});
export const AddNewYahrzeitSchema = Yup.object().shape({
  // mother_name: Yup.string().required("Required"),
  // relation: Yup.string().required("Required"),
  name: Yup.string()
    .required("Required")
    .matches(/^(?![\s-])[\w\s-]+$/, "Enter a valid name"),
  // date_of_death: Yup.string()
  //   .required("Required")
  //   .test("DOB", "Please select valid date of death", (value) => {
  //     return moment().diff(moment(value), "days") >= new Date().getDay();
  //   }),
});

export const classInformation = Yup.object().shape({
  class_name: Yup.string().required("Required"),
  year: Yup.string().required("Required"),
  registration_starts: Yup.string().nullable().required("Required"),
  registration_ends: Yup.string().nullable().when("alwaysAvailable", {
    is: false,
    then: Yup.string().nullable().required("Required"),
    otherwise: Yup.string().nullable().notRequired(),
  }),
  class_capacity: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null ? undefined : Number(originalValue)
    )
    .when("infiniteParticipants", {
      is: false,
      then: Yup.number().typeError("Required").required("Required").min(1, "Must be at least 1"),
      otherwise: Yup.number().nullable().notRequired(),
    }),
  age_range: Yup.string()
    .required("Required")
    .matches(/^\d+-\d+$/, 'Age range should be in the format "min-max"')
    .test('range', 'Max range should be greater than min range', function (value) {
      if (!value) {
        return true;
      }
      const [min, max] = value.split('-').map(Number);
      return max > min;
    }),
});

export const classPricing = Yup.object().shape({
  tuition: Yup.number().required("Required"),
  registration_fee: Yup.number().required("Required"),
  deposit: Yup.number().required("Required"),
  tuition_ledger: Yup.string().required("Required"),
  registration_fee_ledger: Yup.string().required("Required"),
  deposit_ledger: Yup.string().required("Required"),
  total_amount_ledger: Yup.string().required("Required"),
});
export const createForm = Yup.object().shape({
  form_name: Yup.string().required("Required"),
});
export const invoicePayment = Yup.object().shape({
  payment_date: Yup.string().required("Required"),
  amount: Yup.string().required("Required"),
  noOfPayment: Yup.string().required("Required"),
  readioOption: Yup.string().required("Required"),
});

export const addLedgerSchema = Yup.object().shape({
  led_acc_name: Yup.string().required("Required"),
  year: Yup.string().required("Required"),
});
export const addSubCategorySchema = Yup.object().shape({
  sub_cat_name: Yup.string().required("Required"),
  year: Yup.string().required("Required"),
});

export const addProductSchema = Yup.object().shape({
  prod_name: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
  year: Yup.string().required("Required"),
  price: Yup.string().required("Required"),
  prod_tax: Yup.string().when("checked", {
    is: true,
    then: Yup.string().required("Enter Tax Value"),
  }),
});

export const eventTypeSettings = Yup.object().shape({
  name: Yup.string()
    .required("Required")
    .trim()
    .min(1, "Minimum 1 symbols"),
});



export const addNewUserFromSchema = Yup.object().shape({
  family_name: Yup.string()
    .required("Required")
    // .matches(/^(?![\s-])[\w\s-]+$/, "Enter a valid name"),
});